export default timeUnitPerService => {
    const hours = Math.floor(timeUnitPerService / 60);
    const minutes = timeUnitPerService % 60;
    return {
        hours,
        minutes,
    };
};
